// Nadrama <https://nadrama.com>
// Copyright Nadrama Pty Ltd
// All rights reserved.
import { externalNavigationURL } from "./navigation-url";

// navigateExternal performs intentional navigation away from the SPA origin.
export function navigateExternal(destination: string) {
  location.assign(externalNavigationURL(destination, location.href));
}
